import React, { Component } from 'react';

class Footer extends Component {
    render() {
        return (
            <footer>
                All models showcased are examples by <a href="https://innovation.rocks">innovation.rocks</a>
            </footer>
        );
    }
}

export default Footer;